<template>
  <div>
    <header>
      <div class="main">
        <img class="banner" src="../assets/img/董事长致辞_banner.png" />
        <div class="left"></div>
        <div class="center"></div>
        <div class="right"></div>
      </div>
    </header>

    <main class="ceo-mac">
      <div class="main2 contentWrapper">
        <div class="left"></div>
        <div class="center contentWrapper-content">
          <h1>董事长十八周年庆典致辞</h1>
          <p>
            尊敬的时常委、尊敬的各级领导、各届朋友、亲爱的昌恩智能全体同仁：<br />&nbsp;<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大家晚上好！<br />&nbsp;<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;今天是个好日子，在此辞旧迎新之际，我谨代表昌恩智能向一如既往支持和帮助我们发展的各级领导和社会各届朋友、昌恩智能全体员工表示衷心的感谢！并向支持你们的家人致以节日的问候！祝大家新年快乐、身体健康、家庭幸福、万事如意！<br />&nbsp;<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;特别感谢能亲临现场参加活动的每一位朋友，你们放弃自己的休息时间，来到这偏远的东部华侨城现场参加活动，给昌恩捧场，有了你们的支持、有了你们的鼓励，昌恩智能一定会发展得更好，再次向你们表示感谢！<br />&nbsp;<br />感谢昌恩智能会务组日日夜夜的付出，是你们无私的奉献，才能在这么短的时间内让答谢会顺利举行；也感谢活动的承办单位：深圳市润森文化传播有限公司，是你们的全程配合、尽心服务，才能让会场布置得如此赏心悦目；感谢中国深商总会对你们的推荐，让我们体验了你们的专业，相信不久的将来，润森一定会打造出自己响亮的品牌；也感谢茵特拉根国际宴会厅的全体工作人员，是你们默默的付出、精心的准备、热情的服务，才让我们有宾至如归的感觉；<br />&nbsp;<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;感谢礼品团队为我们尊贵的来宾精心设计的纪念礼品，让我们可以在美丽的东部华侨城品广东十大名茶之首的“一号山茶”；可以在忙碌的生活中戴先进智能科技的“智能手表”；可以在晚宴时尝广东省客家商会提供的十八年纯酿“厚工坊”，谢谢！<br />&nbsp;<br />还要感谢深圳市委市政府对民营企业的大力支持，你们是务实的领导班子、是创新的领导班子，是你们的支持，才能让深圳的民营企业走在全国的前面，是你们的支持，才能让深圳的经济一直保持领先全国，是你们的支持，才能使深圳的创新领跑全球。昌恩智能作为深圳民营经济的一分子，能在这样好的环境下发展，是我们的荣幸！<br />&nbsp;<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;配合马兴瑞同志提出的东进战略，我们六月份开始对盐田进行考察，得到盐田区政府的大力支持，并两次派出区经济促进局的相关领导到我们福田区昌恩智能公司总部进行考察，介绍盐田的发展优势，推介盐田的发展战略，希望昌恩智能公司总部搬迁到盐田来发展，补盐田区国家高新技术企业的短板。<br />&nbsp;<br />经过多次的沟通磨合，我们终于来了，乔迁到了风水宝地----盐田区保发大厦。感谢在整个乔迁过程中付出辛勤劳动的昌恩智能全体同仁，感谢你们对昌恩智能的眷恋，放弃福田中心区交通的便利条件，员工没有一个因搬迁而离职，全部追随公司一同搬迁到了盐田，使公司能够稳定运作、平滑过渡；感谢盐田区政府相关部门在搬迁过程中给予的大力支持，提供相关政策咨询、给出办事指南、提供办事便利、并提供廉租房，解决了部分员工的住宿困难；还要特别感谢为我们提供购买办公用房信息的梅县乡贤谢俊铭同志，是您提供及时、有价值的信息，让我们更坚定了搬迁到盐田的决心，是您默默的支持，让我们再次体现了深圳速度，在短短几个月的时间就完成了考察、谈判、签约、缴款、过户、装修及乔迁的所有手续，谢谢！<br />&nbsp;<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2016年，是昌恩智能十八周岁成年礼的一年，18年的发展历程，就象是人生的成长，昌恩从孕育、出生、学爬、学走、幼儿园、小学、初中、高中，终于走进了大学阶段，真正拥有了自己独立的思唯方式、独立的人格，有了自己做人做事的标准，明白了何事可为，何事不可为。18年来，昌恩同仁同心同德、奋力拼搏、克服了一个又一个的困难，取得了一个又一个阶段性的成果，在此，我向一直追随昌恩的全体同仁表示感谢，谢谢你们对昌恩智能的付出，是你们的不离不弃、是你们的无私奉献，才能让昌恩一直走到18周岁，也需要你们的继续前行，昌恩才能走得更稳健、更长远，昌恩智能取得的每一份成绩，都是你们努力奋斗的结果，都有你们的辛劳和汗水。同时，还要感谢默默支持与奉献的我的太太、我的家人，是你们帮我解决了后顾之忧，才能让我大胆地前行，谢谢！<br />&nbsp;<br />2016年，是昌恩智能走向资本市场的一年，在公司十八周年之际，按预定计划，2月17日全国股转系统正式受理申请，5月3日得到正式批复，5月20日在全国股转系统正式挂牌交易，从此，健全法人治理结构、规范公司经营管理成了昌恩人成年后的行为准则；在此我代表昌恩智能向第三方服务机构表示感谢，他们是：东海证券股份有限公司、亚太集团会计师事务所、广东信达律师事务所，是你们的辅导、规范、付出，才能让昌恩智能在短短的五个多月就完成了股改、审计、资料编写、内核、报送、反馈、审批、取号、正式挂牌交易等一系列的工作。还要感谢前期尽调过程中为我们提出合理化建议的华创证券有限公司、瑞华会计师事务所，是你们的建议，让我们认识了很多资本市场的本质，让我们及时调整了方向，使得整个股改进程顺利进行。<br />&nbsp;<br />昌恩智能将在盐田区委区政府的领导下，在智慧城市建设、智能交通方面发挥自己的专长，为市民提供更加便捷、更加智能的生活体验，并将与大家一起，共度青春岁月，共走风雨历程，共担社会责任；我们以“领跑全球智能”为愿景，以“智慧改变生活”为使命，以“昌我中华、恩泽四海”为己任，以“诚信、执着、敬业、学习、感恩”的核心价值观为行为准则，倾尽全力为全球智能化事业做出自己的贡献！<br />&nbsp;<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;乔迁到盐田，是我们新的起点，背靠着雄伟壮观的梧桐山，面朝着美丽如画的大鹏湾，昌恩公司将不忘初心，继续前进！最后，我以一副对联献给大家共勉。
          </p>
        </div>
        <!-- <div class="right"></div> -->
      </div>
    </main>

    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },
  name: "ceo",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
header {
  height: 173px;
}
#app {
  overflow: hidden;
}

.main2 {
  position: relative;
  /* height:1770px; */
}
.main2 .center {
  /* width: 1170px; */
  width: 100%;
  margin: 74px auto 100px;
}
.center h1 {
  /* margin-top: 60px; */
  margin-bottom: 33px;
  font-size: 29px;
  color: #140047;
  line-height: 39px;
  letter-spacing: 2px;
  font-family: AlibabaPuHuiTiB;
}
.center p {
  /* width: 100%;
  height: 100%;
  font-size: 18px;
  font-weight: 400;
  color: #01021b;
  line-height: 29px;
  letter-spacing: 1px;
  opacity: 0.72;
  text-indent: 8px; */

  font-size: 20px;
  font-weight: 400;
  color: #01021b;
  line-height: 29px;
  letter-spacing: 1px;
  opacity: 0.72;
  text-indent: 8px;
}
.main .center p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.58);
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/ceo.vue